<template>
    <div class="progress">
        <div class="step_case active_step">
            <div class="step">1</div>
            <span class="info">{{ lang.userValidatorLang }}</span>
        </div>
        <div class="line" :class="step == 2 || step == 3 ? 'active_line' : ''"></div>
        <div class="step_case" :class="step == 2 || step == 3 ? 'active_step' : ''">
            <div class="step">2</div>
            <span class="info">{{ lang.setNewPasswordLang }}</span>
        </div>
        <div class="line" :class="step == 3 ? 'active_line' : ''"></div>
        <div class="step_case" :class="step == 3 ? 'active_step' : ''">
            <div class="step">3</div>
            <span class="info">{{ lang.successLang }}</span>
        </div>
    </div>
</template>

<script>
import lang from '../../../common/language/new_login';
export default {
    props: ['step'],
    data() {
        return {
            lang: lang
        };
    }
};
</script>
<style lang="scss" scoped>
.progress {
    display: flex;
    // justify-content: space-between;
    justify-content: space-around;
    align-items: center;
    padding: 30px;
    border-bottom: 1px solid #e8e8e8;
    .step_case {
        flex: 1;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .step {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #eeeeee;
            color: #b8b8b8;
            font-size: 24px;
            line-height: 50px;
            margin-bottom: 15px;
        }
        .info {
            width: 88px;
            color: #999999;
        }
    }

    .line {
        // flex: 1;
        width: 365px;
        height: 4px;
        background: #eeeeee;
        margin: 0 30px;
        margin-bottom: 30px;
    }
    .active_step {
        .step {
            background-color: #3391ff;
            color: #fff;
        }
        .info {
            color: #3391ff;
        }
    }
    .active_line {
        background-color: #3391ff;
    }
}
</style>
